import {ChangeDetectionStrategy, Component, Inject, Input} from "@angular/core";

import * as angular from "angular";
import {Service} from "../../../models/service.model";

require('./service-price-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-service-price-dialog',
  templateUrl: './service-price-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicePriceDialogComponent {


  @Input() service: Service;

  constructor(@Inject('deliveriesService') private deliveriesService, @Inject('$mdDialog') private $mdDialog) {
  }

  ngOnInit(): void {
  }

  onOpenPriceDialog(event) {
    event.stopPropagation();
    this.deliveriesService.getDeliveryBilling(this.service.id).then((billing) => {
      this._openDialog(event, this.service, billing);
    })
  }

  private _openDialog(event, service, billing) {

    this.$mdDialog.show({
      template: '<service-pricing service="vm.service" billing="vm.billing"></service-pricing>',
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      bindToController: true,
      locals: {
        service: service,
        billing: billing
      },
      controllerAs: 'vm',
      controller: function () {
      }
    });
  }
}
